import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	ITest,
	LabelPosition,
	RHookFormNumberFieldWithLabel,
	SinNumberRHF,
} from "@websential/cosmic-v20";
import { FC, useEffect } from "react";

import { Grid } from "@mui/material";

interface IEmployeeStatutoryHolidaySetupFieldsPanel extends ITest {
	formMethods: any;
	selectedDataRecord: any;
}
export let provinceResponce: any = undefined;
export const EmployeeStatutoryHolidaySetupFieldsPanel: FC<IEmployeeStatutoryHolidaySetupFieldsPanel> = ({
	formMethods,
	selectedDataRecord,
}) => {
	return (
		<>
			{selectedDataRecord && selectedDataRecord.address.province.shortCode && selectedDataRecord.employeePayroll.provinceOfEmployment.shortCode && selectedDataRecord.address.province.shortCode !== selectedDataRecord.employeePayroll.provinceOfEmployment.shortCode && <EnhancedDropDownRHFWithLabel
				label="Statutory Holidays Based on"
				selectName="statutoryHolidaysBasedOn"
				testId={`Statutory-Holidays-Based-on`}
				labelPosition={LabelPosition.Top}
				items={[{ label: "Province of Employment", value: 100 }, { label: "Province of Residence", value: 200 }]}
				selectedItem={100}
			/>}
			<EnhancedDropDownRHFWithLabel
				label="Holiday Pay Calculation"
				selectName="holidayPayCalculation"
				testId={`Holiday-Pay-Calculation`}
				labelPosition={LabelPosition.Top}
				items={[{ label: "Calculate", value: 100 }, { label: "Do not Calculate", value: 200 }]}
				selectedItem={100}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Apply Company Formula"
				selectName="applyCompanyFormula"
				testId={`Apply-Company-Formula`}
				labelPosition={LabelPosition.Top}
				items={[{ label: "Yes", value: 200 }, { label: "No", value: 100 }]}
				selectedItem={200}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Continuous Operation"
				selectName="continuousOperation"
				testId={`Continuous-Operatio`}
				labelPosition={LabelPosition.Top}
				items={[{ label: "Yes", value: 200 }, { label: "No", value: 100 }]}
				selectedItem={100}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Work Arrangement"
				selectName="workArrangement"
				testId={`Work-Arrangement`}
				labelPosition={LabelPosition.Top}
				items={[{ label: "Yes", value: 200 }, { label: "No", value: 100 }]}
				selectedItem={100}
			/>
			<Grid
				container
				sx={{
					display: "flex",
					mb: "2.1rem",
				}}
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
			>
				<Grid
					size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}
					sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem" }}
				>
					Payment Method (Not Worked)
				</Grid>

				<Grid
					size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
					sx={{ color: "rgba(0, 0, 0, 0.6)", textAlign: "right", fontSize: ".875rem" }}
				>
					Formula Show Here
				</Grid>
			</Grid>

			<Grid
				container
				sx={{
					display: "flex",
					mb: "2.1rem",
				}}
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
			>
				<Grid
					size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}
					sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem" }}
				>
					Payment Method (Worked)
				</Grid>

				<Grid
					size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
					sx={{ color: "rgba(0, 0, 0, 0.6)", textAlign: "right", fontSize: ".875rem" }}
				>
					Formula Show Here
				</Grid>
			</Grid>

			<RHookFormNumberFieldWithLabel id={"holidayPayOpenBalance"} testId={'Holiday-Pay-Open-Balance'} label={"Holiday Pay Open Balance"} />
		</>
	);
};
